import tools from '@/composables/tools'

const SEQ_KEY = 'alquiler_ui_seq'
const FLOW_KEY = 'alquiler_ui_flow'

function detalleATexto(detail?: string | Record<string, unknown> | number | boolean | null): string {
    if (detail == null || detail === '') return ''
    if (typeof detail === 'string' || typeof detail === 'number' || typeof detail === 'boolean') {
        return String(detail)
    }
    try {
        return JSON.stringify(detail)
    } catch {
        return ''
    }
}

/**
 * Tracking de interacciones UI de alquileres (secuencias en tracking_laravel).
 * Prefijo [alquiler_ui #N] para filtrar y ordenar pasos de un mismo flujo.
 */
export function alquilerUiBeginFlow(flow: 'elegir' | 'puntual' | 'recurrente' | string): void {
    try {
        sessionStorage.setItem(FLOW_KEY, flow)
        sessionStorage.setItem(SEQ_KEY, '0')
    } catch {
        /* ignore */
    }
    alquilerUiLog('entrar_pantalla', { flow })
}

export function alquilerUiLog(
    action: string,
    detail?: string | Record<string, unknown> | number | boolean | null
): void {
    let seq = 0
    let flow = 'alquiler'
    try {
        seq = parseInt(sessionStorage.getItem(SEQ_KEY) || '0', 10) + 1
        sessionStorage.setItem(SEQ_KEY, String(seq))
        flow = sessionStorage.getItem(FLOW_KEY) || 'alquiler'
    } catch {
        seq = Date.now() % 100000
    }

    const extra = detalleATexto(detail)
    const event = `[alquiler_ui #${seq}] ${flow} · ${action}${extra ? ' · ' + extra : ''}`

    tools().setLog(event, 'info', {
        model: 'alquiler_ui',
        action,
        model_id: seq,
    })
}
